export * from '@primeuix/themes/material/textarea';
export { default } from '@primeuix/themes/material/textarea';
